import { EstadoSistemaSeguridad } from "./EstadoSistemaSeguridad";

export class SistemaSeguridad {
    id: string;
    nombre: string;
    ultimoEstado: EstadoSistemaSeguridad;
}